import { range } from '@udemy/shared-utils';
import classNames from 'classnames';
import React from 'react';
import { Block } from '../block/block.react-component';
import { Skeleton } from '../skeleton/skeleton.react-component';
import styles from "./course-card-skeleton.module.css";

/**
 * ### The CourseCardSkeleton component.
 */
export const CourseCardSkeleton = _ref => {
  let {
    className,
    imageStyle,
    lineCount = 3,
    size = 'medium',
    width = 'flexible',
    ...htmlProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Skeleton, Object.assign({}, htmlProps, {
    "data-purpose": "course-card-skeleton",
    className: classNames({
      className,
      [styles['skeleton-fixed']]: width === 'fixed',
      [styles['skeleton-flexible']]: width === 'flexible',
      [styles['skeleton-small']]: size === 'small',
      [styles['skeleton-medium']]: size === 'medium',
      [styles['skeleton-large']]: size === 'large'
    })
  }), /*#__PURE__*/React.createElement(Block, {
    className: styles.image,
    style: imageStyle
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Block, {
    className: styles.title
  }), range(lineCount).map(i => /*#__PURE__*/React.createElement(Block, {
    key: i,
    className: styles.line
  }))));
};
//# sourceMappingURL=course-card-skeleton.react-component.js.map